export const validateEwbPartB = ({
  ewbNo,
  transMode,
  vehicleNo,
  transDocNo,
}: {
  ewbNo: string | number;
  transMode: string;
  vehicleNo: string;
  transDocNo: string;
}) => {
  if (!ewbNo) return "E-Way Bill number is required";
  if (transMode === "1" && !vehicleNo?.trim()) return "Vehicle No is required";
  if (transMode !== "1" && !transDocNo?.trim()) return "Transport Document No is required";
  return "";
};

export const buildEwbPartBPayload = ({
  gstin,
  ewbNo,
  vehicleNo,
  fromPlace,
  fromState,
  reasonCode,
  reasonRem,
  transDocNo,
  transDocDate,
  transMode,
  vehicleType,
}: {
  gstin: string;
  ewbNo: number;
  vehicleNo?: string;
  fromPlace?: string;
  fromState?: string | number;
  reasonCode?: string;
  reasonRem?: string;
  transDocNo?: string;
  transDocDate?: string;
  transMode: string;
  vehicleType: string;
}) => ({
  gstin,
  ewbNo,
  vehicleNo: transMode === "1" ? vehicleNo?.trim() || null : null,
  fromPlace: fromPlace || undefined,
  fromState: fromState ? Number(fromState) : undefined,
  reasonCode: reasonCode || undefined,
  reasonRem: reasonRem || undefined,
  transDocNo: transDocNo || undefined,
  transDocDate: transDocDate || undefined,
  transMode,
  vehicleType,
});
